import { Injector } from "@angular/core";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { ListView } from "../../../Data/ListView";
import { ATCcodeAutoUploadEntity } from "../Entity/ATCcodeAutoUploadEntity";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";


export class TreeNodeMedicinalProductsProductATC extends Art57NodeList{

    items: any;
    cloningNode: boolean = false;
    constructor(injector: Injector, parent: any, cloningNode: boolean, items: any[]|undefined) {
        super(injector, new ListView(), `Drug ATCs (${items?items.length:'-'})`);
        this.parent = parent;
        this.cloningNode = cloningNode;
        this.labelNodeName = 'Drug ATCs'
        this.items = items;

        if (this.cloningNode) {
            return;
        }

        for (const item of items || []) {
            this.children?.push(new ATCcodeAutoUploadEntity(injector,item.atccode,this,item,false,true, false));
        }
    }

    override getHeaders(): string[] {
        return ['ATC Code'];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductsProductATC = new TreeNodeMedicinalProductsProductATC(this.ioc!,newParent, true, this.items);        
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
         if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
     });
      
      clonedNode.cloningNode = false;
      return clonedNode;
    }
}